<template>
  <div id="app">
    <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav>
    <router-view/>
  </div>
</template>

<style>
html,
body {
  height: 50%;
}

body {
  margin: 0; /* Remove default margin to ensure full coverage */
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #f0f0f0; /* Replace with your desired background color */
}

#app {
  min-height: 100%; /* Ensure #app stretches to at least the full viewport height */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}


nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #df8417;
}

nav a.router-link-exact-active {
  color: #1d5fcc;
}
</style>
